import type { LandingCourse } from "../types/landing.types";

/** UI values used in LANDING_SORT_OPTIONS */
export type CatalogSortValue = "newest" | "price-asc" | "price-desc";

/** API `sortBy` query values for GET /class/api/v1/by-level/{level2Id} */
export const CATALOG_SORT_API_MAP: Record<CatalogSortValue, string> = {
  newest: "NEWEST",
  "price-asc": "PRICE_ASC",
  "price-desc": "PRICE_DESC",
};

export const DEFAULT_CATALOG_SORT: CatalogSortValue = "newest";

export function toSortQueryParam(sortBy: string): string {
  return (
    CATALOG_SORT_API_MAP[sortBy as CatalogSortValue] ??
    CATALOG_SORT_API_MAP.newest
  );
}

export function sortCatalogCourses(
  courses: LandingCourse[],
  sortBy: string
): LandingCourse[] {
  const result = [...courses];

  switch (sortBy) {
    case "price-asc":
      result.sort((a, b) => a.price - b.price);
      break;
    case "price-desc":
      result.sort((a, b) => b.price - a.price);
      break;
    case "newest":
    default:
      result.sort((a, b) =>
        (b.createdAt ?? "").localeCompare(a.createdAt ?? "")
      );
      break;
  }

  return result;
}
